import { render } from "./LayerSimpleAgreeModal.vue?vue&type=template&id=507ee197&scoped=true&ts=true"
import script from "./LayerSimpleAgreeModal.vue?vue&type=script&lang=ts"
export * from "./LayerSimpleAgreeModal.vue?vue&type=script&lang=ts"

import "./LayerSimpleAgreeModal.vue?vue&type=style&index=0&id=507ee197&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507ee197"]])

export default __exports__